import React, { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

const PriceDisplay = ({ unitPrice, sx = {}, iconSize = 20, textSx = {} }) => {
  // Memoize to prevent expensive re-initialization
  const formattedValue = useMemo(() => {
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: unitPrice % 1 !== 0 ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(unitPrice);
  }, [unitPrice]);

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ ...sx }}
      aria-label={`Price: ${formattedValue} Rupees`}
    >
      <CurrencyRupeeIcon
        sx={{
          fontSize: iconSize,
          mr: 0.5,
          // CRITICAL FIX: Optical adjustment
          // Icons often sit 1-2px lower than text baselines visually.
          // We nudge it up slightly without affecting the layout flow.
          transform: "translateY(-1px)",
          display: "block", // Removes residual line-height spacing from inline-block
        }}
      />
      {/* <Typography variant="body1" component="span" fontWeight="600"> */}
      <Typography
        variant="inherit"
        color="inherit"
        sx={{
          // fontWeight: 600,
          lineHeight: 1,
          ...textSx,
        }}
      >
        {formattedValue}
      </Typography>
    </Box>
  );
};

export default PriceDisplay;
